import type { Collection } from 'state/utils/types';

export type BdrValuationCalendarsBlackoutDatesState = Collection<string[]>;

export const initialBdrValuationCalendarsBlackoutDatesState = {};
